"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProposalDataset = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const Dataset_1 = require("../Dataset");
/**
 * Proposal Dataset
 */
class ProposalDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Method to create Proposal
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link ProposalCreateRequest}
         * @returns
         */
        this.create = (req) => this.sendRequest(interfaces_1.WEN_FUNC.createProposal)(req);
        /**
         * Method to approve Proposal
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link ApproveProposalRequest}
         * @returns
         */
        this.approve = (req) => this.sendRequest(interfaces_1.WEN_FUNC.approveProposal)(req);
        /**
         * Method to reject Proposal
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link RejectProposalRequest}
         * @returns
         */
        this.reject = (req) => this.sendRequest(interfaces_1.WEN_FUNC.rejectProposal)(req);
        /**
         * Method to vote on Proposal
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link ProposalVoteRequest}
         * @returns
         */
        this.vote = (req) => this.sendRequest(interfaces_1.WEN_FUNC.voteOnProposal)(req);
        /**
         * TODO
         *
         * @param startAfter
         * @returns
         */
        this.getAllActiveLive = (startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['settings.endDate', 'approved'],
                fieldValue: [new Date().toISOString(), true],
                operator: [interfaces_1.Opr.GREATER_OR_EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['settings.endDate'],
                orderByDir: ['asc'],
            };
            return this.getManyAdvancedLive(params);
        };
        /**
         * TODO
         *
         * @param space
         * @param startAfter
         * @returns
         */
        this.getActiveLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'settings.endDate', 'approved'],
                fieldValue: [space, new Date().toISOString(), true],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.GREATER_OR_EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['settings.endDate'],
                orderByDir: ['asc'],
            };
            return this.getManyAdvancedLive(params);
        };
        /**
         * TODO
         *
         * @param space
         * @param startAfter
         * @returns
         */
        this.getCompletedLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'settings.endDate', 'approved'],
                fieldValue: [space, new Date().toISOString(), true],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.LESS_OR_EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['settings.endDate'],
                orderByDir: ['asc'],
            };
            return this.getManyAdvancedLive(params);
        };
        /**
         * TODO
         *
         * @param space
         * @param startAfter
         * @returns
         */
        this.getDraftLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'rejected', 'approved'],
                fieldValue: [space, false, true],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: [],
                orderByDir: [],
            };
            return this.getManyAdvancedLive(params);
        };
        /**
         * TODO
         *
         * @param space
         * @param startAfter
         * @returns
         */
        this.getRejectedLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'rejected'],
                fieldValue: [space, true],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: [],
                orderByDir: [],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.ProposalDataset = ProposalDataset;
